import {t} from 'i18next';
import Button from '../components/Button';
import {Panel, PanelCol, PanelContainer, Triangle} from '../components/Panel';

import Picture from '../assets/images/picture-02.svg';
import PictureTriangle from '../assets/images/triangle.svg';
import Header from '../components/Header';

const Home = () => {
  return (
    <>
      <Header />
      <PanelContainer>
        <Panel>
          <PanelCol>
            <Triangle src={PictureTriangle} alt="" />
            <img src={Picture} alt="" />
          </PanelCol>
          <PanelCol>
            <h1>{t('landing.title')}</h1>
            <p dangerouslySetInnerHTML={{__html: t('landing.subtitle')}}></p>
            <Button>
              <a
                href="https://game2value.it/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('landing.cta')}
              </a>
            </Button>
          </PanelCol>
        </Panel>
      </PanelContainer>
    </>
  );
};

export default Home;
